module.exports = __webpack_public_path__ + "img/logo-4.3bedb340.svg";